module.exports = __webpack_public_path__ + "static/media/Ryan.f31fe13f.png";